export enum ColorTypes {
	PRIMARY = 'color',
	SECONDARY = 'secondaryColor',
	POINT = 'pointColor',
	SECONDARY_POINT = 'secondaryPointColor',
	PERIOD_OVER_PERIOD = 'popColor',
	SECONDARY_PERIOD_OVER_PERIOD = 'secondaryPopColor'
}